module.exports = __webpack_public_path__ + "img/5.03b1dd8a.png";